
import { combineReducers } from 'redux';

import filtersTableQuotations from './filtersTableQuotations';
import quotationsSlopes from './quotationsSlopes';
import quotationsSlopesToEmit from './quotationsSlopesToEmit';
import quotationsEmitted from './quotationsEmitted';

const tableQuotations = combineReducers({
  filtersTableQuotations,
  quotationsSlopes,
  quotationsSlopesToEmit,
  quotationsEmitted,
});

export default tableQuotations;
